import { computed } from 'vue';

export function useProgramPreview() {
  const route = useRoute();
  const pin = computed(() =>
    typeof route.query.pin === 'string' ? route.query.pin : ''
  );
  const isPreview = computed(() => pin.value !== '');

  function tabUrl(path: string): string {
    return isPreview.value
      ? `${path}?${new URLSearchParams({ pin: pin.value })}`
      : path;
  }

  return { pin, isPreview, tabUrl };
}
